<template>
    <div>
        <vue-fab mainBtnColor="#3599DB" :scrollAutoHide=false>
            <fab-item :idx="0" title="WMS Wiki" icon="search" color="rgba(74, 255, 134, 0.863" />
            <fab-item @clickItem="support" :idx="1" title="Support" icon="help_outline"
                color="rgba(255, 74, 74, 0.863)" />
        </vue-fab>

        <div v-if="showModal">
            <b-modal size="lg" class="support" v-model="showModal" title="Support Request">
                <div class="modal-content">
                    <div class="modal-headerfrm">
                        <h5 class="modal-title">Support Request</h5>
                        <button type="button" class="close" @click="showModal = false;" data-dismiss="modal"
                            aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-bodyfrm" style="padding: 2rem 1rem 0rem 1rem;">
                        <div class="col-md-12">
                            <b-form-fieldset>
                                <support-request></support-request>
                            </b-form-fieldset>
                        </div>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>
  
<script>

import SupportRequest from './supportrequest'

export default {
    name: 'float',
    components: {
        SupportRequest
    },
    data() {
        return {
            mainBtnColor: '#3eaf7c',
            showModal: false
        }
    },
    methods: {
        support: function () {
            this.showModal = true;
        }
    }
}
</script>
  


// WEBPACK FOOTER //
// src/views/components/float.vue?6532075d